import { customAlphabet } from 'nanoid';

const generateNumericId = customAlphabet('0123456789', 15);

export const generateTransactionId = () => {
	return generateNumericId();
};
